import React, { useState } from "react";

//package import

import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  useTheme,
  Typography,
  Box,
} from "@mui/material";

import { Link, NavLink, useLocation } from "react-router-dom";

//user import

import { pouRoutes, RoutesUrls } from "../../../../Services/Routes/APP";
import {
  DashBoardIcon,
  SettingIcon,
  InventoryMenuIcon,
  RequestIcon,
} from "../../../../Svg";
import { Circle } from "@mui/icons-material";
import { Logo } from "../../../../Svg";

//constants

const sideList = [
  {
    id: 331,
    title: "Dashboard",
    icon: <DashBoardIcon />,
    link: pouRoutes?.dashboard,
  },

  {
    id: 333,
    title: "Inventory",
    icon: <InventoryMenuIcon />,
    categories: [
      // {
      //   title: "All",
      //   link: "#",
      // },
      {
        title: "Vaccines",
        link: pouRoutes?.batch,
      },
      // {
      //   title: "Medical Equipment",
      //   link: "#",
      // },
      // {
      //   title: "Medicines",
      //   link: "#",
      // },
      {
        title: "Others",
        link: "#",
      },
    ],
  },
  {
    id: 334,
    title: "Requests",
    icon: <RequestIcon />,
    categories: [
      {
        title: "Sent",
        link: pouRoutes?.requests,
      },
      {
        title: "Received",
        link: pouRoutes?.requests,
      },
      {
        title: "Request inventory",
        link: pouRoutes?.request_inventory,
      },
    ],
  },
  {
    id: 335,
    title: "Setting",
    icon: <SettingIcon />,
    link: pouRoutes?.setting,
  },
];

//component

export const InsideDrawer = () => {
  //hooks

  const theme = useTheme();
  const location = useLocation();

  //states
  const [navbarEl, setNavbarEl] = useState(
    `${sideList[0]?.id}-user-route-${0}`
  );
  const [open, setOpen] = useState(false);

  //render

  return (
    <Box>
      <Box padding={2}>
        <Typography
          color={"common.white"}
          variant="h4"
          fontWeight={"bold"}
          align="center"
        >
          <Logo />
        </Typography>
      </Box>
      <List>
        {sideList?.map((item, index) => (
          <NavLink
            key={`${item?.id}-user-route-${index}`}
            to={item?.categories ? "#" : RoutesUrls?.pouAdmin + item?.link}
            style={{
              textDecoration: "none",
              color: "inherit",
            }}
            component={item?.categories ? "button" : "a"}
            className={"active_link"}
          >
            <ListItemButton
              sx={{
                backgroundColor: "transparent",

                padding: theme.spacing(1.5, 1.5, 1.5, 4),
                "&.Mui-selected": {
                  backgroundColor: "inherit !important",
                },
              }}
              onClick={() => {
                const NAVBAR_EL = `${item?.id}-user-route-${index}`;
                if (item?.categories) {
                  if (NAVBAR_EL === navbarEl) {
                    setNavbarEl(null);
                  } else {
                    setNavbarEl(NAVBAR_EL);
                  }
                } else {
                  setNavbarEl(NAVBAR_EL);
                }
                setOpen(!open);
              }}
              selected={`${item?.id}-user-route-${index}` === navbarEl}
            >
              <ListItemIcon sx={{ color: "inherit" }}>
                {item?.icon}
              </ListItemIcon>
              <ListItemText
                primary={item?.title}
                sx={{
                  color: theme.palette.common.white,
                }}
              />
            </ListItemButton>
            {item?.categories && (
              <Collapse in={`${item?.id}-user-route-${index}` === navbarEl}>
                <List disablePadding>
                  {item?.categories?.map((category, index) => (
                    <NavLink
                      key={`${category?.title}-user-route-${index}`}
                      to={
                        category?.link === "#"
                          ? "#"
                          : RoutesUrls?.pouAdmin + category?.link
                      }
                      state={{ type: category.title.toLowerCase() }}
                      style={{
                        textDecoration: "none",
                        textSizeAdjust: "small",
                      }}
                      className={"active_link"}
                    >
                      <ListItem
                        sx={{
                          backgroundColor: "transparent",
                          color: "#96abd5",
                          padding: theme.spacing(0.8, 1, 0, 9),
                          "&.Mui-selected": {
                            backgroundColor: "transparent",
                            color: "white",
                          },
                        }}
                        button
                        selected={
                          location?.state?.type ===
                          category?.title?.toLowerCase()
                        }
                      >
                        <ListItemIcon
                          sx={{
                            color: "inherit",
                          }}
                        >
                          <Circle style={{ transform: "scale(0.6)" }} />
                        </ListItemIcon>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography style={{}}>
                              {category?.title}
                            </Typography>
                          }
                          sx={{
                            margin: "-1.5rem",
                          }}
                        />
                      </ListItem>
                    </NavLink>
                  ))}
                </List>
              </Collapse>
            )}
          </NavLink>
        ))}
      </List>
    </Box>
  );
};
